/*global chrome*/
import * as types from "services/actionTypes";

import config from "config";

const { SET_PARAMS } = types;

let applicationID = config.CC_APP_ID;

const outputDebugMessages = true;

const namespace = "urn:x-cast:com.qwizard.chromecast";
let session = null;

let quizData = null;
let store = null;

window["__onGCastApiAvailable"] = function (isAvailable) {
  if (isAvailable) {
    initializeCastApi();
  }
};

document.addEventListener("deviceready", function (e) {
  initializeCastApi();
});

const debugLog = (msg) => {
  if (outputDebugMessages) console.debug(msg);
};

const receiverMessageListener = (message) => {
  debugLog("receiver.messageHandler", message);

  // DO SOMETHING

  var msg = JSON.parse(message);
  console.log(msg);
  if (msg.message !== "debug" && msg.message !== "status") {
    switch (message) {
      case "resuming...":
        console.log("resuming connection to CC");
        //TODO - do something
        break;
      case "getConfig":
        //TODO - do something
        break;
      default:
      //TODO - do something
    }
    // if (msg.message === "currentState") {
    //   debugLog("setting current state");
    //   //console.log(quizConfig.getFormat(), msg.data);
    //   //quizConfig.getFormat().isPartyQwiz || $rootScope.$broadcast('setCurrentState', msg.data);
    //   //_state.setState(msg.data.state);
    //   //musicPlayer.setPlaying(msg.data.music)
    // }
    //debugLog(message);
  }
};

const onConnectListener = () => {
  debugLog("getting receiver app state...");
  // quizConfig.getFormat().isPartyQwiz || gc.send({type:'message',message:'getState'});
};

/**
 * utility function to log messages from the receiver
 * @param {string} namespace The namespace of the message
 * @param {string} message A message string
 */
function receiverMessage(namespace, message) {
  debugLog("receiverMessage: " + namespace + ", " + message);
  if (typeof receiverMessageListener === "function") {
    //debugger;
    receiverMessageListener(message);
  }
}

function sessionListener(e) {
  debugLog("New session ID:" + e.sessionId);
  session = e;
  addSessionListeners();

  debugLog("resuming...");
  if (typeof onConnectListener == "function") {
    onConnectListener();
  }
}

/**
 * listener for session updates
 */
function sessionUpdateListener(isAlive) {
  var message = isAlive ? "Session alive" : "Session dead";

  if (session) {
    message += ": " + session.sessionId;
  }

  debugLog(message);

  if (!isAlive) {
    session = null;
    store.dispatch({ type: types.CC_DISCONNECTED });
  } else {
    debugLog("CC - onListenerUpdate");
    loadConfigOnConnect();
    store.dispatch({ type: types.CC_CONNECTED });
  }
}

const onError = (e) => {
  debugLog(e);
};
const onSuccess = (e) => {
  debugLog(e);
};

function addSessionListeners() {
  debugLog("CC - addSessionListeners");
  session.addUpdateListener(sessionUpdateListener);
  session.addMessageListener(namespace, receiverMessage);
}

const connect = (data) => {
  debugLog("CC - connect");
  quizData = data;
  return requestSession(loadConfigOnConnect);
};

function requestSession(callback) {
  // debugger;
  // console.log("requesting session");
  // callback();
  chrome.cast.requestSession(function (e) {
    // console.log(e);
    console.log("###connect success");
    debugLog(e);
    session = e;
    addSessionListeners();
    //console.log("###connect success");
    if (typeof callback === "function") callback();
  }, onSessionError);
  return true;
}

function onSessionError(e) {
  console.log(e);
}

function loadConfigOnConnect() {
  store.dispatch({ type: types.CC_CONNECTED });
  debugLog("CC - loadConfigOnConnect");
  console.log(quizData.user, quizData.quizData);
  loadConfig(quizData.user, quizData.quizData);
}

function loadConfig(user, quiz) {
  debugLog("CC - loadConfig");

  sendMessage({
    type: SET_PARAMS,
    message: SET_PARAMS,
    customerId: user.userDetails.customerId,
    quizId: quiz.quizId,
  });
}

/**
 * receiver listener during initialization
 */
function receiverListener(e) {
  if (e === "available") {
    if (receiverMessageListener !== null) {
      if (session !== null) {
        debugLog("CC - session found");
        addSessionListeners();
        store.dispatch({ type: types.CC_CONNECTED });
      } else {
        store.dispatch({ type: types.CC_DISCONNECTED });
        debugLog("CC - session not found");
      }
    } else {
      debugLog("receiverMessageListener not found");
    }

    debugLog("CC - receiver found");
  } else {
    debugLog("CC - receiver list empty");
  }
}

function sendMessage(message) {
  function send() {
    session.sendMessage(
      namespace,
      message,
      onSuccess.bind(this, "Message sent: " + JSON.stringify(message)),
      onError
    );
  }

  debugLog("###sending message:", message);

  try {
    send();
  } catch (e) {
    // debugger;
    debugLog(e);
    chrome.cast.requestSession(function (e) {
      session = e;
      addSessionListeners();
      send();
    }, onError);
  }
}

const initializeCastApi = function () {
  try {
    var sessionRequest = new chrome.cast.SessionRequest(applicationID);
    var apiConfig = new chrome.cast.ApiConfig(
      sessionRequest,
      sessionListener,
      receiverListener
    );

    chrome.cast.initialize(apiConfig, onInitSuccess, onError);
  } catch (e) {
    setTimeout(() => initializeCastApi(), 1000);
  }
};

/**
 * stop app/session
 */
function stopApp(cb) {
  debugLog("stopApp");

  if (session) {
    session.stop(function () {
      onStopAppSuccess(cb);
    }, onError);
  } else {
    cb();
  }
}

/**
 * callback on success for stopping app
 */
function onStopAppSuccess(cb) {
  debugLog("onStopAppSuccess");
  session = null;
  cb();
}

function onInitSuccess() {
  debugLog("onInitSuccess");
}

const loadIntro = () => {
  sendMessage({ type: "message", message: "loadIntro" });
};
const loadRounds = () => {
  sendMessage({
    type: "message",
    message: "loadIntro",
    page: "rounds",
  });
};
const loadPrizes = () => {
  sendMessage({
    type: "message",
    message: "loadIntro",
    page: "prizes",
  });
};

const reload = () => {
  sendMessage({ type: "message", message: "reload" });
};

const refresh = () => {
  sendMessage({ type: "message", message: "refresh" });
};

const toggleDebug = () => {
  sendMessage({ type: "message", message: "toggleDebug" });
};

const getSession = () => {
  return session;
};

const quit = () => {
  stopApp(() => console.log("force quit"));
};

const setStore = (globalStore) => {
  store = globalStore;
};

const ChromeCastController = {
  sendMessage,
  connect,
  loadConfig,
  isConnected: function () {
    return session != null;
  },
  loadIntro,
  loadRounds,
  loadPrizes,
  reload,
  refresh,
  toggleDebug,
  getSession,
  quit,
  setStore,
};

export default ChromeCastController;
